export const CREATE_ALERT = 'ALERTS/CREATE'
export const CLOSE_ALERT = 'ALERTS/CLOSE'